<div *ngIf="visible" class="absolute inset-0 z-50 flex items-center justify-center">
    <div
        class="bg-white border border-border shadow-xl rounded-2xl p-6 w-[90%] max-w-[500px] flex justify-between items-start relative">
        <!-- Message -->
        <div class="flex flex-col gap-2 text-warning-600">
            <h1 class="font-bold">{{ header | transloco }}</h1>
            <p>{{ description | transloco }}</p>
        </div>

        <!-- Close Button -->
        <button (click)="hideVisible()"
            class="absolute top-3 right-3 text-warning hover:text-black transition-colors">
            <svg width="20" height="20" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor"
                    d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z" />
            </svg>
        </button>
    </div>
</div>